import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';

import { EventEmitter, BROWSER_SCROLLED } from '../reducers/browser';

// import { connect } from 'react-redux';
import connect from '../utils/connect';

import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import Onboarding from '../components/frontpageonboard';
import Timeline from '../containers/timeline/timeline';
import CookieNotice from '../containers/cookie/notice';

import * as ErrorActions from '../actions/errors';
import * as BrowserActions from '../actions/browser';
import * as MenuActions from '../actions/menus';
import * as CaseActions from '../actions/cases';
import * as EditorialActions from '../actions/editorials';
import * as UserActions from '../actions/users';
import * as TimelineActions from '../actions/timelines';

import without from 'lodash/without';

const MENU_CLASSES = [
	'',
	'body--menu',
	'body--context-menu',
];

class App extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
		users: PropTypes.object.isRequired,
		params: PropTypes.object.isRequired,
		menu: PropTypes.object.isRequired,
		editorials: PropTypes.object.isRequired,
		cases: PropTypes.object.isRequired,
		categories: PropTypes.object.isRequired,
		timelines: PropTypes.object.isRequired,
		ads: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
		children: PropTypes.object,
	};

	constructor(props) {
		super(props);

		bindActionCreators(BrowserActions.listenToBrowserResize, props.dispatch)();
		this.footerMagic = this.footerMagic.bind(this);

		setTimeout(() => {
			props.dispatch(BrowserActions.updateBrowserSize());
		}, 100);

		this.actions = {
			errorActions: bindActionCreators(ErrorActions, props.dispatch),
			menuActions: bindActionCreators(MenuActions, props.dispatch),
			caseActions: bindActionCreators(CaseActions, props.dispatch),
			editorialActions: bindActionCreators(EditorialActions, props.dispatch),
			userActions: bindActionCreators(UserActions, props.dispatch),
			timelineActions: bindActionCreators(TimelineActions, props.dispatch),
		};

		if (!props.users.id) {
			this.actions.userActions.getLogin();
		}

		if (props.params.menuactive) {
			this.state.menuActive = true;
		}
	}

	componentWillMount() {
		// if (!this.props.menu.mainMenu.length) {
		// 	this.actions.menuActions.fetchMenu('header');
		// }
	}

	componentDidMount() {
		this.props.browser.scroll.register(this.footerMagic);
		// this.props.browser.setDocumentElement(this.refs.appscroller);
	}

	componentDidUpdate() {
		const removeClasses = without(MENU_CLASSES, ...['', this.getMenuActiveClass()]);

		// console.log(this.state.menuActive + ' - ' + this.getMenuActiveClass());
		removeClasses.length && document.body.classList.remove(...removeClasses);
		if (this.getMenuActiveClass()) {
			document.body.classList.add(this.getMenuActiveClass());
		}

		this.footerMagic();
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.footerMagic);
	}

	render() {
		// let stickyFooterStyles = {};
		// if (this.state.footerHeight) {
		// 	stickyFooterStyles = {
		// 		paddingBottom: this.state.footerHeight + 'px',
		// 		marginBottom: '-' + this.state.footerHeight + 'px',
		// 	};
		// }

		return (
			<div
				ref='appContainer'
				onClick={() => {
					if (this.props.menu.menuActive || this.props.menu.searchActive) this.props.dispatch({ type: 'MENU_CLOSE' });
				}}
			>
				<div className='app-container'>
					<Header
						browser={this.props.browser}
						{...this.actions}
						{...this.props.menu}
						editorials={this.props.editorials}
						cases={this.props.cases}
						categories={this.props.categories}
						showTimelineFilter={this.isTimeline()}
						timelines={this.props.timelines}
						user={this.props.users}
						ads={this.props.ads}
						dispatch={this.props.dispatch}
						errors={this.props.errors}
					/>
					<Onboarding />
					<div className='main-container'>
						{this.props.children || <Timeline />}
					</div>
					<Footer footerItems={(this.props.menu.footer && this.props.menu.footer.items) ? this.props.menu.footer.items : []} />
					<CookieNotice />
				</div>
			</div>
		);
	}

	isTimeline() {
		if (this.props.router && this.props.router.routes && this.props.router.routes.length) {
			return this.props.router.routes[this.props.router.routes.length - 1].showFilter;
		}

		// return (
		//	(typeof this.props.children === 'undefined') ||
		//	(this.props.children.type.displayName === 'Connect(Timeline)')
		// );
		return false;
	}

	onScroll() {
		EventEmitter.emit(BROWSER_SCROLLED, {
			scrollY: this.refs.appscroller.scrollTop,
		});
		// let newPerf = performance.now();
		// console.log(this.refs.appscroller.scrollTop + ' - DIFF: ' + (newPerf - oldPerf));
		// oldPerf = newPerf;
	}

	getMenuActiveClass() {
		return (this.props.menu.menuActive || this.props.menu.searchActive) ? MENU_CLASSES[1] : MENU_CLASSES[0];
	}

	// _handleResize() {
	// 	var footerHeight = document.querySelector('.footer-container').clientHeight;
	// }

	footerMagic(scroll) {
		const contextualMenu = document.querySelector('.contextual-menu__control');
		const footerContainer = document.querySelector('.footer-container');

		if (contextualMenu && footerContainer && scroll) {
			const context = contextualMenu;
			const footer = footerContainer;

			if (scroll.scrollY + this.props.browser.window.height >= footer.offsetTop) {
				let push = -(scroll.scrollY + this.props.browser.window.height - footer.offsetTop);
				push += 'px';
				push = 'translatey(' + push + ')';
				context.style.transform = push;
			} else {
				let push = 0;
				push += 'px';
				push = 'translatey(' + push + ')';
				context.style.transform = push;
			}
		}
	}
}

export default connect(App);



/** WEBPACK FOOTER **
 ** ./frontend/containers/app.js
 **/